import { AgGridAutocompleteEditorComponent } from '@app/ui/ag-grid-cell-editor/ag-grid-autocomplete-editor.component';
import { AgGridCellEditComponent } from '@app/ui/ag-grid-cell-renderer/ag-grid-cell-edit.component';
import { AgGridCellOrderNumComponent } from '@app/ui/ag-grid-cell-renderer/ag-grid-cell-order-num.component';
import { AgGridCellPlantComponent } from '@app/ui/ag-grid-cell-renderer/ag-grid-cell-plant.component';
import { AgGridCellSymbolComponent } from '@app/ui/ag-grid-cell-renderer/ag-grid-cell-symbol.component';
import { AgGridNumericEditorComponent } from '@app/ui/ag-grid-cell-editor/ag-grid-numeric-editor.component';
import { AgGridNumericUpdateEventEditorComponent } from '@app/ui/ag-grid-cell-editor/ag-grid-numeric-update-event-editor.component';
import { ProductAutocompleteChiplistComponent } from '@app/ui/autocomplete-chiplist/products/product-autocomplete-chiplist.component';
import { CheckBoxMultiSelectComponent } from '@app/ui/checkbox-multi-select/checkbox-multi-select.component';
import { CheckboxMultiSelectPipe } from '@app/ui/checkbox-multi-select/checkbox-multi-select.pipe';
import { ChipListDescriptionPipe } from '@app/ui/autocomplete-chiplist/autocomplete-chiplist-description.pipe';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ExpandablePanelComponent } from '@app/ui/expandable-panel/expandable-panel.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormLinkComponent } from '@app/ui/form-link/form-link.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GenericAutocompleteChiplistComponent } from '@app/ui//autocomplete-chiplist/generic-autocomplete-chiplist.component';
import { HorizontalScrollerDirective } from '@app/ui/toolbar/horizontal-scroller.directive';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule
} from '@angular/material/core';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import {
  MAT_MOMENT_DATE_FORMATS,
  MatMomentDateModule,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { NgModule } from '@angular/core';
import { OptionFilterSelectComponent } from '@app/ui/option-filter-select/option-filter-select.component';
import { OptionMultiSelectComponent } from '@app/ui/option-multi-select/option-multi-select.component';
import { SearchToggleComponent } from '@app/ui/search-toggle/search-toggle.component';
import { ReportsModule } from '@app/reports/reports.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SettingDialogComponent } from '@app/ui/shared/settings-dialog.component';
import { SharedModule } from '@app/shared/shared.module';
import { ToolbarComponent } from '@app/ui/toolbar/toolbar.component';

@NgModule({
  declarations: [
    AgGridNumericUpdateEventEditorComponent,
    CheckBoxMultiSelectComponent,
    CheckboxMultiSelectPipe,
    OptionFilterSelectComponent,
    ExpandablePanelComponent,
    FormLinkComponent,
    GenericAutocompleteChiplistComponent,
    SettingDialogComponent,
    AgGridAutocompleteEditorComponent,
    AgGridCellOrderNumComponent,
    AgGridCellPlantComponent,
    AgGridCellEditComponent,
    AgGridCellSymbolComponent,
    AgGridNumericEditorComponent,
    ToolbarComponent,
    ProductAutocompleteChiplistComponent,
    SearchToggleComponent,
    HorizontalScrollerDirective
  ],
  imports: [
    ChipListDescriptionPipe,
    CommonModule,
    DragDropModule,
    FormsModule,
    FontAwesomeModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatOptionModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatToolbarModule,
    OptionMultiSelectComponent,
    ScrollingModule,
    SharedModule,
    ReactiveFormsModule,
    ReportsModule
  ],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
  ],
  exports: [
    AgGridAutocompleteEditorComponent,
    AgGridNumericEditorComponent,
    ExpandablePanelComponent,
    FormLinkComponent,
    ToolbarComponent,
    OptionMultiSelectComponent,
    ProductAutocompleteChiplistComponent,
    SearchToggleComponent,
    CheckBoxMultiSelectComponent,
    GenericAutocompleteChiplistComponent
  ]
})
export class UIModule {}
